import type { BoardType, EquipmentKind } from '@/types/equipment'

export const BOARD_TYPE_LABEL: Record<BoardType, string> = {
  softboard: 'Softboard',
  longboard: 'Longboard',
  funboard: 'Funboard (Mini Malibu)',
  midlength: 'Midlength',
  fish: 'Fish',
  shortboard: 'Shortboard',
  gun: 'Gun'
}

export const BOARD_TYPE_DESCRIPTION: Record<BoardType, string> = {
  softboard: 'Ideal para iniciantes, espuma macia e segura',
  longboard: 'Prancha longa e estável, ótima para ondas pequenas',
  funboard: 'Versátil, boa para progressão',
  midlength: 'Equilíbrio entre performance e facilidade',
  fish: 'Rápida e divertida em ondas pequenas a médias',
  shortboard: 'Alta performance, para surfistas experientes',
  gun: 'Especializada para ondas grandes'
}

export const KIND_LABEL: Record<EquipmentKind, string> = {
  surfboard: 'Prancha'
}

// Tamanhos comuns de prancha no formato X'Y" (validado por /\A\d+'\d+"\z/ no model).
// Lista curada para o usuário escolher num Select em vez de digitar livremente.
export const BOARD_SIZES: string[] = [
  '5\'6"', '5\'8"', '5\'10"', '5\'11"',
  '6\'0"', '6\'2"', '6\'4"', '6\'6"', '6\'8"', '6\'10"',
  '7\'0"', '7\'2"', '7\'4"', '7\'6"', '7\'8"', '7\'10"',
  '8\'0"', '8\'2"', '8\'4"', '8\'6"', '8\'8"', '8\'10"',
  '9\'0"', '9\'2"', '9\'4"', '9\'6"', '9\'8"', '9\'10"',
  '10\'0"', '10\'2"', '10\'6"'
]

export function boardTypeLabel(type: BoardType | null | undefined): string {
  if (!type) return '—'
  return BOARD_TYPE_LABEL[type] ?? type
}

export function kindLabel(kind: EquipmentKind | null | undefined): string {
  if (!kind) return '—'
  return KIND_LABEL[kind] ?? kind
}
